import Meta from 'src/components/meta/Meta';

const PrivacyPolicyMeta = () => <Meta
  title="Privacy Policy | BrickX"
  description="Our Privacy Policy outlines how BrickX manages any personal information that we collect in connection with your use of the BrickX Platform."
/>;

export default PrivacyPolicyMeta;
